export default __webpack_public_path__ + "static/media/alert-circle-red.11d4daba.svg";